export enum AnalysisVersionStatus {
  CREATED = 'CREATED',
  CALCULATING = 'CALCULATING',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
}
